import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatCardModule } from '@angular/material/card'
import { MatExpansionModule } from '@angular/material/expansion'
import { AuthGuard, ConfigModule, I18nModule, provideConfig } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { translationOverwrites } from '../../../../../public/asaleocare.translate'
import { CustomErrorModule } from '../../shared/custom-components/custom-error/custom-error.module'
import { CustomSearchInputModule } from '../../shared/custom-components/custom-search-input/custom-search-input.module'
import { CustomTableModule } from '../../shared/custom-components/custom-table/custom-table.module'
import { ProductUpdatesComponent } from './product-updates.component'

@NgModule({
  declarations: [ProductUpdatesComponent],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatCardModule,
    MatExpansionModule,
    CustomSearchInputModule,
    CustomTableModule,
    CustomErrorModule,
    SpinnerModule,
    ConfigModule.withConfig({
      i18n: { resources: translationOverwrites }
    })
  ],
  exports: [ProductUpdatesComponent],
  providers: [
    {
      provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
      useValue: { hideSingleSelectionIndicator: true }
    },
    provideConfig({
      cmsComponents: {
        quartelyUpdateComponent: {
          component: ProductUpdatesComponent,
          guards: [AuthGuard]
        }
      }
    })
  ]
})
export class ProductUpdatesModule {}
